export default __webpack_public_path__ + "static/media/cNFT.cc1c1f28.png";